import validate from 'lib/utils/validationRules';

export function generateRandomString() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

export function escape(string) {
  const element = document.createElement('span');
  const text = document.createTextNode(string);
  element.appendChild(text);

  return element.innerHTML;
}

export function unescape(string) {
  const element = document.createElement('span');
  element.innerHTML = string;

  return element.innerText;
}

export function reverseString(string, separator = '') {
  return string.split(separator).reverse().join(separator);
}

export function getFirstLetterInUppercase(string) {
  if (validate.isEmptyString(string)) {
    return '';
  }

  return string[0].toUpperCase() + string.substr(1);
}

export function getPxOrValue(value, def = null) {
  if (validate.isNumber(value)) {
    return `${value}px`;
  }

  return def || value;
}

/**
 * Производит замену строки при вводе.
 *
 * @param {String} initialValue - Значение для обработки.
 * @param {Array[]|Array} forceReplace — массивы вида ['search', 'replace'],
 * где по первому значению осуществляется поиск и замена на второе значение.
 * Также может принимать вид [['s', 'r'], ['s', 'r']] для множественной замены.
 */
export const replaceString = (initialValue, forceReplace) => {
  let resultValue = String(initialValue);
  const replacements = Array.isArray(forceReplace[0])
    ? forceReplace : [forceReplace];

  replacements.forEach(([searchValue, replaceValue]) => {
    resultValue = resultValue.replace(searchValue, replaceValue);
  });

  return resultValue;
};

export const formatString = (initialValue, formattersRules) => {
  let resultValue = String(initialValue);

  return formattersRules.reduce((acc, curr) => {
    acc = curr(resultValue);
    return acc;
  }, '');
};
